<template>
    <div>
        <div class="title mb-4">
            Atualizar NFs para status 'R' - Rejeitada <helper-gdb text="Processo de atualização de status de Notas Fiscais para tentativa de reenvio"/>
        </div>
        <v-row>
            <v-col cols="12" sm="12">
                <v-btn
                    @click.stop="set_status(SELECT)"
                    :disabled="StateInfoAlunoLoading"
                    >
                    Consultar NFs
                </v-btn>
                <v-btn
                    @click.stop="set_status(UPDATE)"
                    :disabled="StateInfoAlunoLoading"
                    >
                    Alterar Status
                </v-btn>
            </v-col>
            <v-col cols="12" sm="12">
                <span v-for="l, index in log" :key="index">
                    <v-alert color="primary">
                        {{l}}
                    </v-alert>
                </span>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    data: ()=>({
        SELECT: 's',
        UPDATE: 'u',
        log:[],
    }),
    methods:{
        ...mapActions(['SetNFRejeitada']),
        async set_status(action='s'){
            const data = {
                action
            }
            const response = await this.SetNFRejeitada(data)
            if(response.status == 200){
                this.log = response.data
            }else{
                this.log = 'Falha ao processar NFs'
                alert(response.statusText)
            }
        },
    },
    computed:{
        ...mapGetters(['StateInfoAlunoLoading'])
    },
    mounted(){
    }
}
</script>
<style scoped>
.cell-text{
    font-size: 11px;
}
</style>
<style>
tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .03);
}
.datatable_caderno_formando tbody{
    vertical-align: text-top !important;
}
.datatable_caderno_formando tbody tr td,.datatable_caderno_formando thead tr th{
    padding: 5px !important;
}
</style>